module.exports = __webpack_public_path__ + "static/media/logo.918aa505.png";